import axios from 'axios';

// Exported so utils/media.js can resolve /uploads on the same host as the API
export const API_BASE = process.env.REACT_APP_API_URL || 'https://api.worldeye.in/api';
console.log("API_BASE => ", API_BASE);
const api = axios.create({
  baseURL: API_BASE,
  headers: { 'Content-Type': 'application/json' },
});

// Attach JWT token to every request
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle 401 responses globally
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      if (window.location.pathname !== '/login') {
        window.location.href = '/login';
      }
    }
    return Promise.reject(error);
  }
);

// ─── Auth ───
export const authAPI = {
  login: (data) => api.post('/auth/login', data),
  me: () => api.get('/auth/me'),
  updateProfile: (data) => api.put('/auth/profile', data),
  changePassword: (data) => api.put('/auth/change-password', data),
};

// ─── Dashboard ───
export const dashboardAPI = {
  summary: () => api.get('/dashboard/summary'),
  charts: () => api.get('/dashboard/charts'),
  advansity: () => api.get('/dashboard/advansity'),
};

// ─── Users ───
export const usersAPI = {
  getAll: (params) => api.get('/users', { params }),
  getById: (id) => api.get(`/users/${id}`),
  create: (data) => api.post('/users', data),
  update: (id, data) => api.put(`/users/${id}`, data),
  delete: (id) => api.delete(`/users/${id}`),
};

// ─── News ───
export const newsAPI = {
  getAll: (params) => api.get('/news', { params }),
  getStats: (params) => api.get('/news/stats', { params }),
  getById: (id) => api.get(`/news/${id}`),
  create: (data) => api.post('/news', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/news/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/news/${id}`),
  // Remove just the uploaded cover, keeping the article
  removeCover: (id) => api.delete(`/news/${id}/cover`),
};

// ─── Categories (News) ───
export const categoriesAPI = {
  getAll: (params) => api.get('/categories', { params }),
  getById: (id) => api.get(`/categories/${id}`),
  create: (data) => api.post('/categories', data),
  update: (id, data) => api.put(`/categories/${id}`, data),
  delete: (id) => api.delete(`/categories/${id}`),
};

// ─── Main Categories (parent of news categories) ───
export const mainCategoriesAPI = {
  getAll: (params) => api.get('/main-categories', { params }),
  getById: (id) => api.get(`/main-categories/${id}`),
  create: (data) => api.post('/main-categories', data),
  update: (id, data) => api.put(`/main-categories/${id}`, data),
  delete: (id) => api.delete(`/main-categories/${id}`),
};

// ─── Locations (states / cities reference data) ───
export const locationsAPI = {
  getStates: () => api.get('/states'),
  getCities: (stateId) => api.get('/cities', { params: { state_id: stateId } }),
};

// ─── Ads ───
export const adsAPI = {
  getAll: (params) => api.get('/ads', { params }),
  getById: (id) => api.get(`/ads/${id}`),
  create: (data) => api.post('/ads', data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  update: (id, data) => api.put(`/ads/${id}`, data, {
    headers: { 'Content-Type': 'multipart/form-data' },
  }),
  delete: (id) => api.delete(`/ads/${id}`),
  // Remove one creative (image/video) from an ad
  deleteMedia: (id, mediaId) => api.delete(`/ads/${id}/media/${mediaId}`),
  activateLink: (id, linkId) => api.put(`/ads/${id}/links/${linkId}/activate`),
  assign: (id, data) => api.post(`/ads/${id}/assign`, data),
  unassign: (id, userId) => api.delete(`/ads/${id}/assign/${userId}`),
};

// ─── Notifications ───
export const notificationsAPI = {
  getAll: (params) => api.get('/notifications', { params }),
  create: (data) => api.post('/notifications', data),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
  delete: (id) => api.delete(`/notifications/${id}`),
};

// ─── Vehicles ───
export const vehiclesAPI = {
  getAll: (params) => api.get('/vehicles', { params }),
  getById: (id) => api.get(`/vehicles/${id}`),
  create: (data) => api.post('/vehicles', data),
  update: (id, data) => api.put(`/vehicles/${id}`, data),
  delete: (id) => api.delete(`/vehicles/${id}`),
  addChallan: (id, data) => api.post(`/vehicles/${id}/challans`, data),
  addService: (id, data) => api.post(`/vehicles/${id}/services`, data),
};

export default api;
